import type { User } from "~/lib/bosca/security";
import type { AsyncDataExecuteOptions } from "#app/composables/asyncData";

let user: Ref<User | null> | null = null
let refresh: ((opts?: AsyncDataExecuteOptions) => Promise<void>) | null = null

export function useUser(): Ref<User | null> {
    if (user) {
        return user
    }
    const client = useBoscaClient()
    const { data, refresh: r } = client.security.getCurrentUserAsyncData()
    user = data
    refresh = r
    return data
}

export function refreshUser() {
    if (refresh) refresh().then(() => {})
}
